import { CompanyType } from '../types/company.types';

class CompanyUtils {
    static getCompanyTitle(company: CompanyType) {
        return `${company.name}${company.ticker ? ` (${company.ticker})` : ''}`;
    }
}

export default CompanyUtils;
